import { IApplicationState } from '../../types/redux';

export const selectPageTypeSource = (state: IApplicationState): string | null => state.pageTypeSource;
